import styled, { keyframes } from 'styled-components';

import ThemeV2 from '../../../../theme';

import SVGIcon from '../../../../atomic/atoms/SVGIcon';
import ConnectToSlackButton from '../../../../atomic/organism/ConnectToSlack';

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

export const Container = styled.section`
  padding: 24px;
`;

export const SlackContainer = styled.section`
  margin: 8px 0;
  padding: 12px;
  border-radius: 4px;
  border: 1px solid ${ThemeV2.palette.gray5};

  display: flex;
  flex-direction: column;
`;

export const TeamsContainer = styled.section`
  margin-top: 8px;
  border-radius: 4px;
  padding: 8px;
  border: 1px solid ${ThemeV2.palette.gray5};

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const StyledConnectToSlackButton = styled(ConnectToSlackButton)`
  width: 100%;
  margin-top: 8px;
`;

export const LoopIcon = styled(SVGIcon)`
  margin-right: 8px;
  animation: ${rotate} 2s linear infinite;

  path {
    fill: ${ThemeV2.palette.geekBlue6};
  }
`;

export const ActiveBadge = styled.div`
  margin-left: 8px;
  padding: 1px 8px;
  border-radius: 100px;
  background: ${ThemeV2.palette.geekBlue2};
`;

export const DisconnectedBadge = styled.div`
  margin-left: 8px;
  padding: 1px 8px;
  border-radius: 100px;
  background: ${ThemeV2.palette.dustRed2};
`;
